export const PAYONEER_REVOKE_ACCESS_TOKEN_SUCCESS = 'PAYONEER_REVOKE_ACCESS_TOKEN_SUCCESS';
export const PAYONEER_PAYONEER_REVOKE_ACCESS_TOKEN_FAILED = 'PAYONEER_PAYONEER_REVOKE_ACCESS_TOKEN_FAILED';
export const PAYONEER_REVOKE_ACCESS_TOKEN_FETCH = 'PAYONEER_REVOKE_ACCESS_TOKEN_FETCH';
